/**
 * This composition is a workaround to access the VueRouter instance
 * within the `setup()` lifecycle hook.
 *
 * It can be safely removed/refactored when we start using Vue 3 and VueRouter 4.
 */

import { getCurrentInstance } from '@vue/composition-api';

let router = {};

export default function useRouter() {
  const vm = getCurrentInstance();

  if (vm?.$router) {
    router = vm.$router;
  }

  return {
    router,
  };
}
